import React from 'react';
import PropTypes from 'prop-types';
import BaseTypography from './Base';

const Heading = ({
  tag = 'h2',
  textAlign,
  textTransform,
  color,
  children,
  fontSize = 'heading',
  fontWeight = 'bold',
}) => {
  return (
    <BaseTypography
      tag={tag}
      textAlign={textAlign}
      textTransform={textTransform}
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
    >
      {children}
    </BaseTypography>
  );
};

Heading.propTypes = {
  tag: PropTypes.string,
  textAlign: PropTypes.string,
  textTransform: PropTypes.string,
  color: PropTypes.string,
  fontWeight: PropTypes.string,
  fontSize: PropTypes.string,
  children: PropTypes.node,
};

export default Heading;
